import { declareVueComponent } from '/vodalys/vvuejs'

import VrunFormPasswordCellComponent from './VrunFormPasswordCellComponent.vue'

declareVueComponent('vrun-form-password-cell-component', VrunFormPasswordCellComponent)